import {Profile} from '@models';

type KinkScore = {
	label: string;
	combinedAverage: number;
};

const MIN_SHARED_INTEREST = 55;

const INTRO_TEMPLATES = [
	(label: string) => `J'ai vu qu'on partage un intérêt pour ${label}. Qu'est-ce qui te plaît le plus dans cette pratique ?`,
	(label: string) => `On semble tous les deux attirés par ${label}. Tu préfères en parler côté envies, limites ou contexte idéal ?`,
	(label: string) => `Le kink ${label} revient sur nos deux profils. Si ça te va, on peut échanger calmement sur ce qu'on aime chacun.`
];

const FALLBACK_SUGGESTIONS = [
	`J'ai bien aimé ton profil. Qu'est-ce qui est le plus important pour toi au début d'une discussion ?`,
	`Ton profil m'a donné envie de te découvrir. Tu préfères commencer par parler de kinks, de limites ou de ce que tu recherches ?`,
	`On peut prendre le temps d'échanger tranquillement : qu'est-ce qui te met le plus en confiance pour faire connaissance ?`
];

const normalizeKinkLabel = (label: string): string => label.trim().replace(/\s+/g, ' ');

const getProfileKinkMap = (profile?: Profile): Map<string, number> => {
	const map = new Map<string, number>();
	if (!profile?.test?.length) {
		return map;
	}
	profile.test.forEach((entry) => {
		if (typeof entry?.role !== 'string' || typeof entry?.average !== 'number') {
			return;
		}
		const normalizedLabel = normalizeKinkLabel(entry.role);
		if (!normalizedLabel) {
			return;
		}
		const score = Math.max(0, Math.min(100, entry.average));
		map.set(normalizedLabel, score);
	});
	return map;
};

const buildSharedKinkRanking = (currentProfile?: Profile, targetProfile?: Profile): KinkScore[] => {
	const currentMap = getProfileKinkMap(currentProfile);
	const targetMap = getProfileKinkMap(targetProfile);
	const shared: KinkScore[] = [];

	currentMap.forEach((currentAverage, label) => {
		const targetAverage = targetMap.get(label);
		if (targetAverage === undefined) {
			return;
		}
		if (currentAverage < MIN_SHARED_INTEREST || targetAverage < MIN_SHARED_INTEREST) {
			return;
		}
		shared.push({
			label,
			combinedAverage: currentAverage + targetAverage
		});
	});

	return shared.sort((a, b) => b.combinedAverage - a.combinedAverage);
};

export const generateIcebreakerSuggestions = (currentProfile?: Profile, targetProfile?: Profile): string[] => {
	const sharedKinks = buildSharedKinkRanking(currentProfile, targetProfile);
	const suggestions: string[] = [];

	for (let i = 0; i < Math.min(sharedKinks.length, 3); i++) {
		const kink = sharedKinks[i];
		suggestions.push(INTRO_TEMPLATES[i % INTRO_TEMPLATES.length](kink.label));
	}

	let fallbackIndex = 0;
	while (suggestions.length < 3) {
		suggestions.push(FALLBACK_SUGGESTIONS[fallbackIndex % FALLBACK_SUGGESTIONS.length]);
		fallbackIndex++;
	}

	return suggestions.slice(0, 3);
};
